import React from 'react'
import Modal from '../../../../ui_reusable/Modal'
import { Button } from 'rsuite'

const SwitchModelModal = ({ open, onClose, onConfirm }) => {
  if (!open) {
    return null
  }

  return (
    <Modal open={open} onClose={onClose} title="Switch Model">
      <Modal.Body>
        <p>If you switch models you will lose all your work. Continue?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onConfirm} appearance="primary">
          Continue
        </Button>
        <Button onClick={onClose} appearance="subtle">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SwitchModelModal
